"use client";
import React from "react";
import { SiteLogo } from "@/components/svg";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

interface MenuItem {
  title: string;
  href: string;
}

interface ActionButtonConfig {
  href: string;
  label: string;
}

interface HorizontalHeaderMobileProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
  filteredMenus: MenuItem[];
  actionButtonConfig: ActionButtonConfig | null;
}

const HorizontalHeaderMobile: React.FC<HorizontalHeaderMobileProps> = ({
  mobileMenuOpen,
  setMobileMenuOpen,
  filteredMenus,
  actionButtonConfig,
}) => {
  return (
    <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
      <SheetContent side="left" className="w-[280px] sm:w-[350px]">
        <SheetHeader className="mb-6">
          <SheetTitle>
            <Link
              href="/v1/dashboard"
              onClick={() => setMobileMenuOpen(false)}
            >
              <div className="w-32 h-8">
                <SiteLogo className="w-full h-full" />
              </div>
            </Link>
          </SheetTitle>
        </SheetHeader>

        {/* Mobile Navigation Links */}
        <nav className="flex flex-col space-y-1">
          {filteredMenus.map((item) => (
            <Link
              key={item.title}
              href={item.href}
              className="text-default-900 dark:text-default-100 hover:bg-primary-50 dark:hover:bg-default-800 px-4 py-3 rounded-lg transition-colors text-base font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.title}
            </Link>
          ))}
        </nav>

        {/* Mobile Action Button */}
        {actionButtonConfig && (
          <div className="mt-6 pt-6 border-t border-default-200 dark:border-default-700">
            <Link href={actionButtonConfig.href} onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-bold">
                {actionButtonConfig.label}
              </Button>
            </Link>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default HorizontalHeaderMobile;
